import { OpportunityTypeEnum } from "constants/opportunityTypes";

import InsightCard from "../InsightCard";

const InsightList = ({
    insights,
    isEditModeActive,
    isLoadingInsight,
    isLoadingReportsForTeam,
    opportunityType,
    reports,
    sources,
    setInsightForCompanyRemoval,
    setInsightForDrinkingWaterSystemRemoval,
    setInsightForEdit,
    setInsightForIntelligenceAddition,
    setInsightForLocationRemoval,
    setInsightForSourceCreation,
    setInsightForWasteWaterSystemRemoval,
    setSourceForEdit,
    toggleOverlay,
    isStaff,
}) => {
    const isLoading =
        isLoadingInsight ||
        isLoadingReportsForTeam ||
        reports.length === 0 ||
        insights.length === 0;

    if (
        insights.length === 0 ||
        (opportunityType === OpportunityTypeEnum.REPORT && reports.length === 0)
    ) {
        return null;
    }

    return insights.map((insight, index) => {
        return (
            <InsightCard
                key={insight.id}
                isLoading={isLoading}
                setInsightForEdit={setInsightForEdit}
                toggleOverlay={toggleOverlay}
                setInsightForIntelligenceAddition={setInsightForIntelligenceAddition}
                insight={insight}
                index={index}
                opportunityType={opportunityType}
                sources={sources}
                isStaff={isStaff}
                isEditModeActive={isEditModeActive}
                setSourceForEdit={setSourceForEdit}
                setInsightForLocationRemoval={setInsightForLocationRemoval}
                setInsightForWasteWaterSystemRemoval={
                    setInsightForWasteWaterSystemRemoval
                }
                setInsightForDrinkingWaterSystemRemoval={
                    setInsightForDrinkingWaterSystemRemoval
                }
                setInsightForCompanyRemoval={setInsightForCompanyRemoval}
                setInsightForSourceCreation={setInsightForSourceCreation}
            />
        );
    });
};

export default InsightList;
